import * as React from "react";
const SvgHash01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.965 21v-3.965h-5.93V21a1.035 1.035 0 0 1-2.07 0v-3.965H4a1.035 1.035 0 0 1 0-2.07h2.965v-5.93H4a1.035 1.035 0 0 1 0-2.07h2.965V3a1.035 1.035 0 0 1 2.07 0v3.965h5.93V3a1.035 1.035 0 0 1 2.07 0v3.965H20a1.035 1.035 0 0 1 0 2.07h-2.965v5.93H20a1.035 1.035 0 0 1 0 2.07h-2.965V21a1.035 1.035 0 0 1-2.07 0m-5.93-6.035h5.93v-5.93h-5.93z"
}));
export default SvgHash01;
//# sourceMappingURL=Hash01.js.map